<template>
    <div
        :class="{
            'sm:border-t sm:border-gray-200 sm:py-5' : withBorder,
            'space-y-1 sm:space-y-0 sm:grid sm:grid-cols-3 sm:gap-4': isInline
        }"
    >
        <label v-if="label" :for="id"
               :class="{
                   'block text-sm font-medium text-gray-900': true,
                   'mb-2': !isInline,
                   'sm:mt-px sm:pt-2': isInline
                }"
        >
            {{ label }} {{ required ? '*' : '' }}
        </label>

        <div :class="isInline ? 'sm:col-span-2' : 'w-full'">
            <textarea
                :id="id"
                :name="name"
                v-model="mutableValue"
                :placeholder="placeholder"
                :class="{
                   'placeholder-gray-400 appearance-none rounded-md w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline': true,
                   'border-red-500 border': (errors && errors.length > 0),
                   'border border-gray-300 shadow-sm': withInputBorder
                }"
                @blur="handleBlur"
                @input="handleChange"
                @focus="handleFocus"
                :cols="cols"
                :rows="rows"
            />

            <div v-if="tooltip || errors && errors.length > 0" class="flex flex-col justify-between">
                <p v-if="errors && errors.length > 0" v-for="error in errors" class="text-red-500 text-xs italic">{{ error }}</p>
                <p v-if="tooltip" class="mt-2 text-sm text-gray-500">{{ tooltip }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            id: String,
            name: String,
            placeholder: String,
            label: String,
            tooltip: String,
            modelValue: String,
            errors: Array,
            touched: Boolean,
            withBorder: Boolean,
            required: Boolean,
            isInline: Boolean,
            withInputBorder: {
                type: Boolean,
                default: true
            },
            cols: {
                type: Number,
                default: 30
            },
            rows: {
                type: Number,
                default: 5
            }
        },
        data() {
            return {
                mutableValue: this.modelValue
            }
        },
        methods: {
            handleBlur() {
                this.$emit('blur', this.name);
            },
            handleChange() {
                this.$emit('update:modelValue', this.mutableValue);
            },
            handleFocus() {
                this.$emit("focus", this.mutableValue);
            },
        }
    }
</script>
